import { render } from "./RolesComponent.vue?vue&type=template&id=360b36ac&scoped=true"
import script from "./RolesComponent.vue?vue&type=script&lang=js"
export * from "./RolesComponent.vue?vue&type=script&lang=js"

import "./RolesComponent.vue?vue&type=style&index=0&id=360b36ac&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360b36ac"]])

export default __exports__